import { nameSpace } from "../constants/cardStatement.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const pdfDownloadCardStatement = (state = initialState, action) => {
  switch (action.type) {
    case `DOWNLOADPDF_${nameSpace}_REQUEST`:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case `DOWNLOADPDF_${nameSpace}_SUCCESS`:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case `DOWNLOADPDF_${nameSpace}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case `DOWNLOADPDF_${nameSpace}_RESET`:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
